module.exports = __webpack_public_path__ + "static/media/071-serbia.6288ffc8.svg";